import React from 'react'
import VisaAssistance from '../components/Visa/VisaAssistance'
import ContactSection from '../components/ContactSection'

const VisaPage = () => {
  return (
    <main>
        <VisaAssistance/>
        {/* <NisaTravelAgency/> */}
        {/* <ExploreServices/> */}
        {/* <VisaTypesGrid/> */}
        <ContactSection/>
    </main>
  )
}

export default VisaPage